export function getUrl({
  slug,
  pathname,
  searchParams,
  params,
}: {
  slug?: string | null
  pathname: string
  searchParams: URLSearchParams
  params: { [key: string]: string | undefined }
}): string {
  try {
    if (typeof window === 'undefined') return ''

    const origin = window.location.origin
    const hasIdInParams = !!params?.id

    if (hasIdInParams) {
      return `${origin}${pathname}?${searchParams.toString()}`
    }

    // ✅ Use the slug directly without encoding `/`
    return `${origin}/${slug || ''}`
  } catch (error: any) {
    return ''
  }
}
